import { Subject } from 'rxjs';
import { ContentBlock } from './content-block';


export class ContentBlockEditorComponent<BlockT extends ContentBlock = ContentBlock> {
    block: BlockT;
    private _delayedAutoSave = new Subject<void>();
    readonly delayedAutoSave = this._delayedAutoSave.asObservable();

    locked: boolean;

    protected delayAutoSave() {
        this._delayedAutoSave.next();
    }
}
